import { ChevronRightIcon, HomeIcon } from '@heroicons/react/20/solid';
import React, { FC } from 'react';

const pages = [
  { name: 'Projects', href: '#', current: false },
  { name: 'Project Nero', href: '#', current: true },
];

export type NavLink = {
  name: string;
  href: string;
  current: boolean;
  tooltip?: string;
  id?: string;
};

export type BreadCrumbProps = {
  pages: NavLink[];
};

const BreadCrumb: FC<BreadCrumbProps> = ({ pages }) => {
  if (!!pages && pages.length < 2) return;

  return (
    <nav className="flex" aria-label="Breadcrumb">
      <ol role="list" className="flex items-center space-x-4">
        <li>
          <div>
            <a href="/properties" className="text-gray-400 hover:text-gray-500">
              <HomeIcon className="h-5 w-5 flex-shrink-0" aria-hidden="true" />
              <span className="sr-only">Home</span>
            </a>
          </div>
        </li>
        {pages.map((page) => (
          <li key={page.name}>
            <div className="flex items-center">
              <ChevronRightIcon
                className="h-5 w-5 flex-shrink-0 text-gray-400"
                aria-hidden="true"
              />
              <a
                href={page.href}
                className={`ml-4 text-sm font-medium text-gray-500 hover:text-gray-700 ${
                  page.current ? 'text-gray-900' : ''
                }`}
                aria-current={page.current ? 'page' : undefined}
                title={page.tooltip}
                id={page.id || page.name.toLowerCase().replace(/ /g, '-')}
              >
                {page.name}
              </a>
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default BreadCrumb;
